import React, { useEffect } from 'react';
import styled from 'styled-components';
import { ShowCard } from './ShowCard';
import { useDashboardApi } from '../useDashboardApi';
import { CardSkeletonLoader } from 'app/components/CardSkeletonLoader';

export const UpcomingShows: React.FC = () => {
    const { upcomingShows, getUpcomingShows, upcompingLoading } =
        useDashboardApi();
    useEffect(() => {
        getUpcomingShows();
    }, []);
    if (!upcomingShows || upcomingShows.length === 0) {
        return null; // or you can return a message indicating no upcoming shows
    }
    return (
        <ShowsContainer>
            <ShowsTitle>Upcoming Shows</ShowsTitle>
            <ShowsGrid>
                <>
                    {upcompingLoading ? (
                        <>
                            <CardSkeletonLoader
                                isHeaderLoader
                                headerWidth={240}
                                headerHeight={220}
                            />
                            <CardSkeletonLoader
                                isHeaderLoader
                                headerWidth={240}
                                headerHeight={220}
                            />
                            <CardSkeletonLoader
                                isHeaderLoader
                                headerWidth={240}
                                headerHeight={220}
                            />
                            <CardSkeletonLoader
                                isHeaderLoader
                                headerWidth={240}
                                headerHeight={220}
                            />
                        </>
                    ) : (
                        <>
                            {upcomingShows.map(show => (
                                <ShowCard
                                    key={show.id}
                                    image={show.imageUrl as string}
                                    title={show.name as string}
                                    startDate={show.startDate as string}
                                    endDate={show.endDate as string}
                                    location={show.locationName as string}
                                />
                            ))}
                        </>
                    )}
                </>
            </ShowsGrid>
        </ShowsContainer>
    );
};

const ShowsContainer = styled.section`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: stretch;
  font-weight: 600;
  justify-content: start;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const ShowsTitle = styled.h2`
  align-self: start;
  padding: 10px;
  gap: 10px;
  font-family: Inter, -apple-system, Roboto, Helvetica, sans-serif;
  font-size: 14px;
  color: rgba(0, 0, 0, 1);
  text-align: center;
  letter-spacing: -0.14px;
  line-height: 1.2;
`;

const ShowsGrid = styled.div`
  display: flex;
  margin-top: 7px;
  width: 100%;
  align-items: end;
  gap: 40px;
  font-family: Manrope, -apple-system, Roboto, Helvetica, sans-serif;
  font-size: 12px;
  color: #f3f3f3;
  line-height: 1.3;
  justify-content: start;
  flex-wrap: wrap;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;
